/*
 * «Complete Your Promotion» у кошику — варіант A (рядки-доповнення), 06.09.2026.
 *
 * Дані: /recommendations/products?section_id=cart-recommendations&product_id=<canonical>&intent=complementary
 * → секція віддає JSON по кандидатах (id, title, platform, cardType, addVariant, bundleSpec…).
 * Ранжування/мердж по кількох anchor-ах — та сама логіка, що була в слайдерній версії.
 *
 * Дії:
 *  - Add:     /cart/add.js (addVariant) → лічильники → подія promosound:cart-section-rendered
 *             (script-main-cart сам перерендерить свої регіони; наш блок усередині них →
 *             MutationObserver ре-ініціалізує зі свіжими контекстами)
 *  - Upgrade: кандидат-бандл тієї ж платформи, що бандл у кошику → add нового + change старого рядка на 0
 *  - Choose:  посилання на PDP (parent з пакетами, one-click неможливий)
 *
 * Аналітика (psTrack): cart_rec_impression (рендер), cart_rec_view (≥50% у вʼюпорті, 1 раз на
 * завантаження), cart_rec_add, cart_rec_product_click, cart_rec_option_open (Choose).
 */
(function () {
  const SECTION_ROOT_SELECTOR = '[data-main-cart-section]'
  const BLOCK_ROOT_SELECTOR = '[data-cart-recommendations]'

  let viewTracked = false

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
  }

  function track(name, params, tags) {
    if (typeof window.psTrack === 'function') window.psTrack(name, params || {}, tags || null)
  }

  function trackView(section, recommendations) {
    if (viewTracked || typeof window.IntersectionObserver !== 'function') return
    const cards = recommendations.length
    const firstHandle = recommendations[0]?.product?.handle || ''
    const device = window.matchMedia('(max-width: 768px)').matches ? 'mobile' : 'desktop'
    const observer = new IntersectionObserver((entries) => {
      const visible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.5)
      if (!visible || viewTracked) return
      viewTracked = true
      observer.disconnect()
      track('cart_rec_view', { cards, first_handle: firstHandle, device }, { cart_rec_cards: cards, cart_rec_device: device })
    }, { threshold: [0.5] })
    observer.observe(section)
  }

  function refreshCartCounters() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll('.cart-count').forEach((el) => {
          el.textContent = cart.item_count
          el.setAttribute('data-count', cart.item_count)
        })
        if (window.cart) {
          try {
            window.cart.updateCartCount?.(cart.item_count)
            window.cart.updateCartSummary?.(cart)
          } catch (e) { /* mini-cart sync optional */ }
        }
        return cart
      })
      .catch(() => null)
  }

  function requestCartRerender(root) {
    const host = root.closest('[id^="shopify-section"]')
    const sectionId = host ? host.id.replace('shopify-section-', '') : null
    if (!sectionId || !window.PromoSoundMainCart) {
      window.location.reload()
      return
    }
    document.dispatchEvent(new CustomEvent('promosound:cart-section-rendered', {
      detail: { sectionId, source: 'complementary' },
    }))
    // Страховка: якщо тема не підмінила регіони за ~5с — перезавантажуємо.
    let tries = 0
    const poll = setInterval(() => {
      tries += 1
      if (!root.isConnected) { clearInterval(poll); return }
      if (tries >= 16) { clearInterval(poll); window.location.reload() }
    }, 300)
  }

  function initCartComplementary() {
    const root = document.querySelector(BLOCK_ROOT_SELECTOR)
    if (!root || root.dataset.complementaryReady === '1') return
    root.dataset.complementaryReady = '1'

    const section = root.querySelector('[data-recommendation-block="complementary-services"]')
    const list = root.querySelector('[data-cart-addons-list]')
    const productContextsNode = root.querySelector('[data-cart-product-contexts]')
    if (!section || !list || !productContextsNode) return

    const labels = {
      add: root.dataset.labelAdd || 'Add',
      upgrade: root.dataset.labelUpgrade || 'Upgrade',
      choose: root.dataset.labelChoose || 'Choose package',
      best: root.dataset.labelBest || 'Best match',
      from: root.dataset.labelFrom || 'From',
    }

    let cartProductContexts = []
    try {
      cartProductContexts = JSON.parse(productContextsNode.textContent)
        .map(({ productId, groupId, lineValue, lineKey, isBundle, platform }) => ({
          productId: String(productId || ''),
          groupId: String(groupId || productId || ''),
          lineValue: Math.max(0, Number(lineValue) || 0),
          lineKey: String(lineKey || ''),
          isBundle: Boolean(isBundle),
          platform: String(platform || ''),
        }))
        .filter(({ productId, groupId }) => productId && groupId)
    } catch (error) {
      console.error('[cart-complementary] invalid cart product contexts', error)
      return
    }
    if (!cartProductContexts.length) return

    const recommendationAnchors = [...cartProductContexts
      .reduce((groups, context) => {
        const existing = groups.get(context.groupId)
        if (existing) existing.lineValue += context.lineValue
        else groups.set(context.groupId, { ...context })
        return groups
      }, new Map())
      .values()]
      .sort((left, right) => right.lineValue - left.lineValue)
    const cartExclusionIds = new Set(cartProductContexts.flatMap(({ productId, groupId }) => [productId, groupId]))
    // Дедуп з бампером (#cartBump у правій колонці): той самий продукт не показуємо двічі
    const bumpNode = document.getElementById('cartBump')
    ;[bumpNode?.dataset.bumpProductId, bumpNode?.dataset.bumpParentId]
      .map((id) => String(id || '').trim())
      .filter(Boolean)
      .forEach((id) => cartExclusionIds.add(id))
    const sectionId = root.dataset.sectionId
    const route = root.dataset.recommendationsRoute
    const maximumProducts = Math.min(4, Math.max(3, Number(root.dataset.maximumProducts) || 3, recommendationAnchors.length))

    async function fetchForProduct({ productId, groupId }, anchorOrder) {
      const url = new URL(route, window.location.origin)
      url.searchParams.set('section_id', sectionId)
      // The canonical parent owns the recommendation policy.
      url.searchParams.set('product_id', groupId)
      url.searchParams.set('limit', String(maximumProducts))
      url.searchParams.set('intent', 'complementary')

      const response = await fetch(url.toString(), { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
      if (!response.ok) throw new Error(`HTTP ${response.status}`)

      const fragment = document.createElement('div')
      fragment.innerHTML = await response.text()
      const node = fragment.querySelector('[data-cart-complementary-response]')
      let products = []
      try { products = node ? JSON.parse(node.textContent) : [] } catch (e) { products = [] }

      return products.map((product, anchorPosition) => ({ product, groupId, productId, anchorOrder, anchorPosition }))
    }

    function selectBalancedRecommendations(ranked, perAnchor) {
      const selected = []
      const selectedIds = new Set()
      function add(candidate) {
        if (!candidate || selectedIds.has(candidate.productId) || selected.length >= maximumProducts) return
        selected.push(candidate)
        selectedIds.add(candidate.productId)
      }
      const byScore = (a, b) => (
        b.anchorMatches - a.anchorMatches
        || a.bestAnchorPosition - b.bestAnchorPosition
        || a.firstAnchorOrder - b.firstAnchorOrder
      )
      ;[...ranked.values()].filter((c) => c.anchorMatches > 1).sort(byScore).forEach(add)
      const maximumDepth = Math.max(0, ...perAnchor.map((candidates) => candidates.length))
      for (let depth = 0; depth < maximumDepth && selected.length < maximumProducts; depth += 1) {
        perAnchor.forEach((candidates) => add(candidates[depth]))
      }
      ;[...ranked.values()].sort(byScore).forEach(add)
      return selected
    }

    // Upgrade = кандидат-бандл тієї ж платформи, що бандл-anchor у кошику (наступний тір)
    function findUpgradeTarget(candidate) {
      if (!candidate.product.isBundle || !candidate.product.addVariant) return null
      for (const groupId of candidate.anchorGroups) {
        const line = cartProductContexts.find((ctx) => (
          ctx.groupId === groupId && ctx.isBundle && ctx.lineKey && ctx.platform && ctx.platform === candidate.product.platform
        ))
        if (line) return line
      }
      return null
    }

    function renderRow(candidate, position) {
      const p = candidate.product
      const upgradeLine = findUpgradeTarget(candidate)
      const mode = upgradeLine ? 'upgrade' : (p.addVariant ? 'add' : 'choose')
      const meta = p.isBundle
        ? p.bundleSpec
        : (p.addVariant ? p.addVariant.title : `${p.subproductCount || p.variantCount} options`)
      const priceText = p.addVariant ? p.addVariant.priceFormatted : `${labels.from} ${p.priceMinFormatted}`
      const price = p.addVariant
        ? `${escapeHtml(p.addVariant.priceFormatted)}`
        : `<small>${escapeHtml(labels.from)}</small>${escapeHtml(p.priceMinFormatted)}`
      const hot = position === 1

      const button = mode === 'choose'
        ? `<a class="cart-addon__btn cart-addon__btn--pick" href="${escapeHtml(p.url)}" data-recommendation-action="option-open">${escapeHtml(labels.choose)}</a>`
        : `<button type="button" class="cart-addon__btn${mode === 'upgrade' ? ' cart-addon__btn--upgrade' : ''}" data-recommendation-action="${mode === 'upgrade' ? 'upgrade' : 'add-to-cart'}" data-variant-id="${escapeHtml(p.addVariant.id)}"${upgradeLine ? ` data-replace-line="${escapeHtml(upgradeLine.lineKey)}"` : ''}>${escapeHtml(mode === 'upgrade' ? labels.upgrade : labels.add)}</button>`

      return `
        <li class="cart-addon${hot ? ' cart-addon--hot' : ''}" data-product-id="${escapeHtml(p.id)}" data-position="${position}" data-recommendation-block="complementary-services" data-recommendation-source="shopify-search-and-discovery">
          <span class="cart-addon__icon main-cart__item-icon default ${escapeHtml(p.platform)}" aria-hidden="true"></span>
          <div class="cart-addon__body">
            <a class="cart-addon__name" href="${escapeHtml(p.url)}" data-recommendation-action="product-click">${escapeHtml(p.isBundle && p.bundleName ? p.bundleName : p.title)}${hot ? `<span class="cart-addon__tag">${escapeHtml(labels.best)}</span>` : ''}</a>
            <div class="cart-addon__meta" data-price=" · ${escapeHtml(priceText)}">${escapeHtml(meta)}</div>
          </div>
          <div class="cart-addon__price">${price}</div>
          ${button}
        </li>`
    }

    async function mutateCart(button) {
      const row = button.closest('.cart-addon')
      const variantId = Number(button.dataset.variantId)
      const replaceLine = button.dataset.replaceLine || ''
      if (!variantId || section.dataset.busy === '1') return
      section.dataset.busy = '1'
      section.classList.add('is-busy')
      button.disabled = true
      const original = button.textContent
      button.textContent = '…'
      const checkoutBtn = document.getElementById('mainCheckoutBtn')
      if (checkoutBtn) checkoutBtn.disabled = true

      track(
        'cart_rec_add',
        { product_id: row?.dataset.productId, position: row?.dataset.position, mode: replaceLine ? 'upgrade' : 'add' },
        { used_upsell: 'yes' },
      )

      try {
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        })
        if (!addResponse.ok) throw new Error(`add ${addResponse.status}`)
        if (typeof window.psAddSource === 'function') window.psAddSource(variantId, 'cart-rec')

        if (replaceLine) {
          const changeResponse = await fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: replaceLine, quantity: 0 }),
          })
          if (!changeResponse.ok) throw new Error(`change ${changeResponse.status}`)
        }

        await refreshCartCounters()
        requestCartRerender(root)
      } catch (error) {
        console.error('[cart-complementary] cart mutation failed', error)
        button.disabled = false
        button.textContent = original
        section.dataset.busy = ''
        section.classList.remove('is-busy')
        if (checkoutBtn) checkoutBtn.disabled = false
        window.location.reload()
      }
    }

    async function renderComplementaryProducts() {
      const results = await Promise.allSettled(
        recommendationAnchors.map((context, anchorOrder) => fetchForProduct(context, anchorOrder)),
      )
      const ranked = new Map()
      const perAnchor = recommendationAnchors.map(() => [])

      results.forEach((result) => {
        if (result.status !== 'fulfilled') {
          console.warn('[cart-complementary] recommendation request failed', result.reason)
          return
        }
        const seenForAnchor = new Set()
        result.value.forEach(({ product, groupId, anchorOrder, anchorPosition }) => {
          const productId = String(product?.id || '')
          if (!productId || cartExclusionIds.has(productId) || seenForAnchor.has(productId)) return
          seenForAnchor.add(productId)
          const existing = ranked.get(productId)
          if (existing) {
            existing.anchorMatches += 1
            existing.anchorGroups.add(groupId)
            existing.bestAnchorPosition = Math.min(existing.bestAnchorPosition, anchorPosition)
            existing.firstAnchorOrder = Math.min(existing.firstAnchorOrder, anchorOrder)
            perAnchor[anchorOrder].push(existing)
            return
          }
          const candidate = {
            productId,
            product,
            anchorMatches: 1,
            anchorGroups: new Set([groupId]),
            bestAnchorPosition: anchorPosition,
            firstAnchorOrder: anchorOrder,
          }
          ranked.set(productId, candidate)
          perAnchor[anchorOrder].push(candidate)
        })
      })

      const recommendations = selectBalancedRecommendations(ranked, perAnchor)
      if (!recommendations.length) return   // порожній стан: блок лишається hidden
      if (!root.isConnected) return          // кошик перерендерився, поки летіли запити

      list.innerHTML = recommendations.map((candidate, index) => renderRow(candidate, index + 1)).join('')
      section.hidden = false

      track('cart_rec_impression', { count: recommendations.length })
      trackView(section, recommendations)

      if (!section.dataset.psTrackBound) {
        section.dataset.psTrackBound = '1'
        section.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-recommendation-action]')
          if (!trigger) return
          const action = trigger.dataset.recommendationAction
          const row = trigger.closest('.cart-addon')
          if (action === 'add-to-cart' || action === 'upgrade') {
            event.preventDefault()
            mutateCart(trigger)
            return
          }
          const name = action === 'option-open' ? 'cart_rec_option_open' : 'cart_rec_product_click'
          track(name, { product_id: row?.dataset.productId, position: row?.dataset.position })
        })
      }
    }

    renderComplementaryProducts().catch((error) => {
      console.error('[cart-complementary] render failed', error)
    })
  }

  // 08.09.2026: офер «зібрав платформи вручну → візьми пак». Свап: додати пак і прибрати ті бандли,
  // що вже входять до нього. Один запит /cart/update.js з нульовими кількостями по line key.
  function initPackOffer() {
    const offer = document.querySelector('[data-cart-pack-offer]')
    if (!offer || offer.dataset.psBound === '1') return
    offer.dataset.psBound = '1'
    track('cart_pack_offer_view', {
      pack: offer.dataset.packHandle || '',
      replaced: (offer.dataset.packKeys || '').split(' ').filter(Boolean).length,
    })
    offer.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-pack-swap]')
      if (!button || button.disabled) return
      event.preventDefault()
      const variantId = Number(offer.dataset.packVariant)
      const keys = (offer.dataset.packKeys || '').split(' ').filter(Boolean)
      if (!variantId) return
      button.disabled = true
      const original = button.textContent
      button.textContent = '…'
      offer.classList.add('is-busy')
      track('cart_pack_offer_accept', { pack: offer.dataset.packHandle || '', replaced: keys.length }, { used_upsell: 'yes' })
      try {
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        })
        if (!addResponse.ok) throw new Error(`add ${addResponse.status}`)
        if (typeof window.psAddSource === 'function') window.psAddSource(variantId, 'cart-pack')
        if (keys.length) {
          const updates = {}
          keys.forEach((key) => { updates[key] = 0 })
          const updateResponse = await fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates }),
          })
          if (!updateResponse.ok) throw new Error(`update ${updateResponse.status}`)
        }
        window.location.reload()
      } catch (error) {
        console.error('[cart-pack-offer] swap failed', error)
        button.disabled = false
        button.textContent = original
        offer.classList.remove('is-busy')
        window.location.reload()
      }
    })
  }

  function observeCartRerenders() {
    const sectionRoot = document.querySelector(SECTION_ROOT_SELECTOR)
    if (!sectionRoot || typeof window.MutationObserver !== 'function') return
    // script-main-cart.js робить currentContent.replaceWith(nextContent) — childList на корені секції.
    const observer = new MutationObserver(() => { setTimeout(() => { initCartComplementary(); initPackOffer() }, 0) })
    observer.observe(sectionRoot, { childList: true })
  }

  initCartComplementary()
  initPackOffer()
  observeCartRerenders()
  window.initCartComplementary = initCartComplementary
})()
